export default {
  login: "/login",
  chooseRole: "/choose-role",
  userHome: "/user/home",
  educatorHome: "/educator/home",
  ownerHome: '/owner/company',
  adminHome: '/admin/company',
};
